
export default class WorkspaceService {
    constructor(axios) {
        this.axios = axios;
    }
    getCurrent() {
        return this.axios.get('/workspaces/current');
    }
}
